import './NavigationBetweenSteps.css'
import React from "react";
import {IonButton, IonIcon, IonProgressBar} from "@ionic/react";
import {arrowRedo, arrowUndo} from "ionicons/icons";
import {ProcessStep} from "../../models/ProcessStep";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    componentFromStep: ProcessStep[],
    stepInProgress: ProcessStep,
    movingBackOrForth: (direction: boolean) => void,
}

/**
 * Component allowing to navigate between the different steps of a new installation
 */
class NavigationBetweenSteps extends React.Component<Props> {

    PREVIOUS = true;
    NEXT = false;

    render() {
        const length = this.props.componentFromStep.length;
        const stepInProgress = this.props.stepInProgress;
        const index = this.props.componentFromStep.indexOf(stepInProgress);
        const percentProgression = (index + 1) / length;

        return (
            <div id="navigationBetweenStepContainer">
                <div id="headerProcessContainer">
                    {  // If there is a previous step, the previous button is displayed
                        index > 0 ?
                            <IonButton size="small" onClick={() => this.props.movingBackOrForth(this.PREVIOUS)}>
                                <IonIcon icon={arrowUndo}/>
                            </IonButton>
                            : <div/>
                    }

                    <p id="stepper-description">
                        <span className="stepper-description-element" id="stepper-step-progress">{index + 1} / {length}</span>
                        <span className="stepper-description-element">{this.props.t(stepInProgress.title)}</span>

                    </p>

                    { // If there is a next step, the next button is displayed
                        index < length - 1 ?
                        <IonButton size="small" onClick={() => this.props.movingBackOrForth(this.NEXT)}>
                            <IonIcon icon={arrowRedo}/>
                        </IonButton>
                        : <div/>
                    }
                </div>
                <IonProgressBar id="stepper-progressbar" value={percentProgression}/>
            </div>
        );
    }
}

export default withTranslation()(NavigationBetweenSteps);
